import CacheService from '../cache-service';

class CommunityService extends CacheService {
  getCommunity() {
    return this.getCachedData('/api/community');
  }
}

const communityService = new CommunityService();

export default communityService;